
initBrandsPopup('amrest-brands-popup');

import { initBrandsPopup } from "./../js/brandsPopup/initBrandsPopup";
